import cn from 'classnames/bind'

import PlainTooltip from 'app/common/ui-next/plain-tooltip'
import { isValueZero } from 'app/common/templates-next/table-template'

import { ColumnKey } from './table-columns'
import styles from './header-cell.scss'

const cx = cn.bind(styles)

export const headerCell = <CellData extends { columnKey: string; value?: string | null }>(
  cellData?: CellData,
) => {
  if (!cellData) {
    return <span>{'Поле не задано'}</span>
  }

  const { value, columnKey } = cellData
  const className = cx(styles.limitedCell, styles.root, {
    special: columnKey === ColumnKey.CountFrom1To4 || columnKey === ColumnKey.CountFrom5To11,
    specialWidth:
      /(parentsExpensesFrom1To4|CountFrom1To4|totalFrom1To4|parentsExpensesFrom5To11|CountFrom5To11|totalFrom5To11)/.test(
        columnKey,
      ),
    zero: isValueZero(value),
  })
  if ('value' in cellData) {
    return (
      <PlainTooltip className={className} text={value}>
        {value === null ? '—' : value}
      </PlainTooltip>
    )
  }

  return <span>{'—'}</span>
}
